// src/icons/svgs/quote.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgQuote = (props, ref) => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "none", viewBox: "0 0 28 28", ref, ...props, children: [
  /* @__PURE__ */ jsx("path", { fill: "#343A40", d: "M7 17.5h17.5z" }),
  /* @__PURE__ */ jsx("path", { stroke: "#495057", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.56, d: "M7 17.5h17.5M24.5 22.167H7M17.5 12.833h7M24.5 8.167h-7M10.5 10.5h1.167a1.166 1.166 0 1 1-1.167 1.167V8.75a2.333 2.333 0 0 1 2.333-2.333M3.5 10.5h1.167A1.167 1.167 0 1 1 3.5 11.667V8.75a2.333 2.333 0 0 1 2.333-2.333" })
] });
var ForwardRef = forwardRef(SvgQuote);
var quote_default = ForwardRef;
export {
  quote_default as Quote
};
